import { Swiper, Navigation, Pagination, Autoplay, Lazy } from "swiper";
import("swiper/swiper-bundle.min.css");

Swiper.use([Navigation, Pagination, Autoplay, Lazy]);

export default { Swiper };
